import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon, CalendarDaysIcon } from 'lucide-react';
export function OrientationCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2196">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2197">
        <div className="rounded-xl p-6 md:p-8 border-l-4 shadow-sm" style={{
        backgroundColor: '#ffffff',
        borderColor: '#c8a84b'
      }} data-id="element-2198">
          <div className="flex items-start gap-4" data-id="element-2199">
            <AlertTriangleIcon size={28} className="flex-shrink-0 mt-1" style={{
            color: '#c8a84b'
          }} data-id="element-2200" />
            <div data-id="element-2201">
              <h3 className="text-xl font-bold uppercase mb-3" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2202">
                New Member Orientation
              </h3>
              <p className="text-base mb-3" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2203">
                "New Member Orientation" including a "Live Fire Exam" is{' '}
                <strong className="underline" data-id="element-2204">REQUIRED BEFORE</strong> being
                allowed to use any of the shooting ranges.
              </p>
              <p className="text-base mb-4" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2205">
                Orientations are normally conducted on Wednesdays a week
                following the Club's Business Meeting starting at 6:00pm and
                lasting about three hours.
              </p>
              <div className="flex items-center gap-2" data-id="element-2206">
                <CalendarDaysIcon size={18} style={{
                color: '#c8a84b'
              }} data-id="element-2207" />
                <Link to="/Calendar.html" className="text-sm font-semibold transition-colors hover:underline" style={{
                color: '#1e3d2f',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2208">
                  Check the club calendar for scheduled orientations
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}